import React, { createContext, useContext, useState, useCallback } from "react";

const CATALOG = {
  en: {
    create_cta: "Create Your Magnets", how_cta: "See how it works",
    hero_title2: "Turn your favorite photos into magnets you’ll see every day.",
    hero_support: "Custom photo magnets made from your favorite memories.",
    benefits_title: "Why you'll love them",
    product_detail: "Each magnet is 5\u00d75 cm with rounded corners and an edge-to-edge glossy print \u2014 no borders.",
    hero_line: "Custom photo magnets, handmade from your favorite moments.",
    slogan: "Small Photos. Big Feelings.",
    size_line: "Square 5×5 cm · high-quality print",
    trust_print: "High quality print", trust_gift: "Perfect for gifts",
    trust_memories: "Your favorite memories", trust_decor: "Beautiful home decor",
    how_title: "How it works",
    how_1_t: "Choose your magnets", how_1_d: "Choose your quantity and place your order.",
    how_2_t: "Add your photos", how_2_d: "After checkout, upload your favorite photos now or come back later.",
    how_3_t: "We make & ship them", how_3_d: "We create your magnets and ship them to your door.",
    kits_title: "Choose your kit", kits_sub: "Each magnet is 5×5 cm. Prices in USD.",
    per_magnet: "per magnet", magnets: "magnets", most_popular: "Most popular", best_value: "Best value",
    best_seller: "Best seller", free_shipping: "FREE SHIPPING", starting_at: "Starting at {price}",
    product_size: "5 × 5 cm • Rounded corners • Glossy edge-to-edge print",
    choose: "Choose", free_ship_note: "Free shipping on orders over $100.",
    faq_title: "Frequently asked questions",
    faq_q1: "Can I use the same photo on more than one magnet?", faq_a1: "Yes! Add the same photo to as many magnets as you like.",
    faq_q2: "Do I have to crop my photos?", faq_a2: "No. Upload happens after checkout and we frame your photos for printing. Want a specific crop? Tap Adjust on any photo.",
    faq_q3: "Do I need an account?", faq_a3: "No account or password needed. Just place your order — we email you a secure private link to add your photos and track your order anytime.",
    faq_q4: "How do I track my order?", faq_a4: "Use the secure link from your confirmation email to upload photos and follow your order from payment to production and shipping.",
    footer_admin: "Production area", footer_privacy: "Your photos are kept in private storage and used only to produce your order.",
    step_kit: "Choose your magnets", step_photos: "Add Photos", step_review: "Review", step_contact: "Contact & Shipping", step_gift: "Gift packaging", step_payment: "Payment",
    back: "Back", continue: "Continue",
    photos_hint: "Just upload your favorite photos — we'll take care of the rest.",
    photos_sub: "Want a specific crop? Tap Adjust.",
    quality_note: "For best results, choose clear, high-resolution photos. Photos may be slightly cropped or professionally adjusted for printing.",
    add_photos: "Add Photos", slot_add: "Add", adjust: "Adjust", adjusted: "Adjusted", framing_us: "Framed by us",
    replace: "Replace", remove: "Remove", duplicate: "Duplicate",
    filled_of: "{done} of {total} photos added",
    adjust_title: "Adjust framing", zoom: "Zoom", rotate: "Rotate 90°", reset: "Center", save: "Save", cancel: "Cancel",
    c_name: "Full name", c_email: "Email", c_phone: "Phone (optional)", c_addr: "Shipping address", c_apt: "Apartment / Suite (optional)",
    c_city: "City", c_state: "State", c_zip: "ZIP code", c_country: "Country",
    email_use: "We'll email your order confirmation and updates on payment, production and shipping.",
    subtotal: "Products subtotal", shipping: "Shipping", tax: "Taxes", total: "Total", shipping_next: "Shipping is calculated on the next step.",
    pay_title: "Payment", apple_pay: "Apple Pay", pay_card: "Credit / Debit Card", pay_zelle: "Other option: Zelle",
    apple_note: "Apple Pay appears automatically on supported devices (iPhone/Safari).",
    secure_note: "You'll be redirected to Stripe to complete the payment securely.",
    zelle_note: "Zelle is a manual transfer. Your order is saved and moves to production only after we confirm your payment.",
    gift_title: "Giving some as a gift?", gift_sub: "Add a gift package for up to 6 magnets.",
    gift_each: "Each gift package holds up to 6 magnets.", gift_none: "No, thanks",
    gift_each_price: "{price} each", gift_max_note: "Up to {n} for {qty} magnets",
    gift_packaging: "Gift packaging", gift_optional: "Optional — you can continue without adding any.",
    extras_step: "Make it extra special", addon_add: "Add", addon_added: "Added", addon_remove: "Remove",
    ship_standard: "Standard shipping", ship_free: "FREE", ship_free_unlocked: "You've unlocked FREE shipping!",
    delivery_title: "Estimated delivery", delivery_prod: "Production: {n} business days after your photos are submitted.",
    delivery_transit: "Then about {min}–{max} business days UPS transit.",
    delivery_estimate_note: "These are estimates, not guaranteed delivery dates.",
    shipping_calculated: "Shipping shown below based on your address.",
    copy: "Copy", copied: "Copied!", scan_to_pay: "Or scan to pay",
    zelle_send: "Send with Zelle", amount: "Amount", memo: "Memo", recipient: "Recipient",
    order_received_msg: "We've received your order.", zelle_awaiting_msg: "Your Zelle payment is awaiting confirmation.",
    zelle_memo_help: "Please include your order number in the memo so we can identify your payment.",
    benefit_print_t: "High quality print", benefit_print_d: "Glossy, edge-to-edge, with rounded corners.",
    benefit_gift_t: "Perfect for gifts", benefit_gift_d: "Add gift packaging at checkout.",
    benefit_memories_t: "Your favorite memories", benefit_memories_d: "Your photos, beautifully printed.",
    benefit_decor_t: "Beautiful home decor", benefit_decor_d: "Brighten your fridge and more.",
    play_video: "Play video",
    product_details_title: "Product details",
    pd_size_label: "Size", pd_corners_label: "Corners", pd_finish_label: "Finish", pd_backing_label: "Backing",
    pd_corners_v: "Gently rounded corners", pd_finish_v: "Glossy edge-to-edge photo print — no borders", pd_backing_v: "Flexible magnetic backing",
    custom_card_title: "Choose your quantity", your_price: "Your price",
    cta_video_q: "Ready to turn your photos into magnets?",
    cta_want_mine: "I Want Mine",
    cta_create_now: "Create Yours Now",
    promo_headline: "Your memories belong somewhere you can see them.",
    promo_support: "Turn your favorite photos into magnets made for your fridge.",
    cta_create_q: "Ready to create yours?",
    cta_create_desc: "Turn your favorite photos into magnets made just for you.",
    fo_title: "Get 10% off your first order",
    fo_subtitle: "Enter your email to unlock 10% off your magnets.",
    fo_email_placeholder: "Email address",
    fo_cta: "GET 10% OFF",
    fo_no_thanks: "No thanks",
    fo_invalid_email: "Please enter a valid email address.",
    fo_not_eligible: "This email isn't eligible for the first-order offer.",
    fo_applied_toast: "{pct}% first-order discount applied!",
    fo_savings: "✓ {pct}% first-order discount applied — You save {amt}",
    fo_remove: "Remove",
    fo_original: "Original price",
    fo_discounted: "Discounted magnets",
    first_order_discount_label: "{pct}% first-order discount",
    free_unlocked: "✓ You've unlocked FREE SHIPPING",
    free_away_value: "You're {amt} away from FREE shipping",
    free_hint_value: "Free shipping on orders {amt}+",
    free_away_qty: "Add {n} more magnets to unlock FREE SHIPPING",
    free_hint_qty: "Free shipping at {n}+ magnets",
    lang_label: "EN",
  },
  pt: {
    create_cta: "Criar meus ímãs", how_cta: "Ver como funciona",
    hero_title2: "Transforme suas fotos favoritas em ímãs que você vê todos os dias.",
    hero_support: "Ímãs de foto personalizados feitos com suas memórias favoritas.",
    benefits_title: "Por que você vai amar",
    product_detail: "Cada ímã tem 5×5 cm, cantos arredondados e impressão de ponta a ponta — sem bordas.",
    hero_line: "Ímãs de foto personalizados, feitos à mão com seus momentos favoritos.",
    slogan: "Small Photos. Big Feelings.",
    size_line: "Quadrado 5×5 cm · impressão de alta qualidade",
    trust_print: "Impressão de alta qualidade", trust_gift: "Perfeito para presentear",
    trust_memories: "Suas memórias favoritas", trust_decor: "Decoração linda em casa",
    how_title: "Como funciona",
    how_1_t: "Escolha seus ímãs", how_1_d: "Escolha a quantidade e faça seu pedido.",
    how_2_t: "Adicione suas fotos", how_2_d: "Após o pagamento, envie suas fotos favoritas agora ou depois.",
    how_3_t: "Produzimos e enviamos", how_3_d: "Criamos seus ímãs e enviamos até a sua porta.",
    kits_title: "Escolha o seu kit", kits_sub: "Cada ímã tem 5×5 cm. Preços em USD.",
    per_magnet: "por ímã", magnets: "ímãs", most_popular: "Mais popular", best_value: "Melhor valor",
    best_seller: "Mais vendido", free_shipping: "FRETE GRÁTIS", starting_at: "A partir de {price}",
    product_size: "5 × 5 cm • Cantos arredondados • Impressão brilhante ponta a ponta",
    choose: "Escolher", free_ship_note: "Frete grátis em pedidos acima de $100.",
    faq_title: "Perguntas frequentes",
    faq_q1: "Posso usar a mesma foto em mais de um ímã?", faq_a1: "Sim! Use a mesma foto em quantos ímãs quiser.",
    faq_q2: "Preciso recortar as fotos?", faq_a2: "Não. O envio é feito após o pagamento e nós enquadramos suas fotos para impressão. Quer um recorte específico? Toque em Ajustar em qualquer foto.",
    faq_q3: "Preciso criar conta?", faq_a3: "Não é preciso conta nem senha. Basta fazer o pedido — enviamos por e-mail um link privado e seguro para adicionar suas fotos e acompanhar o pedido quando quiser.",
    faq_q4: "Como acompanho meu pedido?", faq_a4: "Use o link seguro do e-mail de confirmação para enviar as fotos e acompanhar do pagamento à produção e ao envio.",
    footer_admin: "Área da produção", footer_privacy: "Suas fotos ficam em armazenamento privado e são usadas apenas para produzir o seu pedido.",
    step_kit: "Escolha seus ímãs", step_photos: "Adicionar fotos", step_review: "Revisar", step_contact: "Contato & Entrega", step_gift: "Embalagem de presente", step_payment: "Pagamento",
    back: "Voltar", continue: "Continuar",
    photos_hint: "É só enviar suas fotos favoritas — cuidamos do resto.",
    photos_sub: "Quer um recorte específico? Toque em Ajustar.",
    quality_note: "Para melhores resultados, escolha fotos nítidas e de alta resolução. As fotos podem ser levemente recortadas ou ajustadas profissionalmente para impressão.",
    add_photos: "Adicionar fotos", slot_add: "Adicionar", adjust: "Ajustar", adjusted: "Ajustada", framing_us: "Enquadrada por nós",
    replace: "Substituir", remove: "Remover", duplicate: "Duplicar",
    filled_of: "{done} de {total} fotos adicionadas",
    adjust_title: "Ajustar enquadramento", zoom: "Zoom", rotate: "Girar 90°", reset: "Centralizar", save: "Salvar", cancel: "Cancelar",
    c_name: "Nome completo", c_email: "E-mail", c_phone: "Telefone (opcional)", c_addr: "Endereço de entrega", c_apt: "Apartamento / Complemento (opcional)",
    c_city: "Cidade", c_state: "Estado", c_zip: "Código postal", c_country: "País",
    email_use: "Enviaremos a confirmação e atualizações de pagamento, produção e envio por e-mail.",
    subtotal: "Subtotal dos produtos", shipping: "Frete", tax: "Impostos", total: "Total", shipping_next: "O frete é calculado na próxima etapa.",
    pay_title: "Pagamento", apple_pay: "Apple Pay", pay_card: "Cartão de crédito / débito", pay_zelle: "Outra opção: Zelle",
    apple_note: "O Apple Pay aparece automaticamente em dispositivos compatíveis (iPhone/Safari).",
    secure_note: "Você será redirecionado ao Stripe para concluir o pagamento com segurança.",
    zelle_note: "Zelle é uma transferência manual. Seu pedido é salvo e vai para produção apenas após confirmarmos o pagamento.",
    gift_title: "Vai presentear alguém?", gift_sub: "Adicione uma embalagem de presente para até 6 ímãs.",
    gift_each: "Cada embalagem comporta até 6 ímãs.", gift_none: "Não, obrigado",
    gift_each_price: "{price} cada", gift_max_note: "Até {n} para {qty} ímãs",
    gift_packaging: "Embalagem de presente", gift_optional: "Opcional — você pode continuar sem adicionar.",
    extras_step: "Deixe ainda mais especial", addon_add: "Adicionar", addon_added: "Adicionado", addon_remove: "Remover",
    ship_standard: "Frete padrão", ship_free: "GRÁTIS", ship_free_unlocked: "Você ganhou FRETE GRÁTIS!",
    delivery_title: "Entrega estimada", delivery_prod: "Produção: {n} dias úteis após o envio das suas fotos.",
    delivery_transit: "Depois, cerca de {min}–{max} dias úteis de trânsito UPS.",
    delivery_estimate_note: "Estas são estimativas, não datas de entrega garantidas.",
    shipping_calculated: "O frete abaixo é calculado com base no seu endereço.",
    copy: "Copiar", copied: "Copiado!", scan_to_pay: "Ou escaneie para pagar",
    zelle_send: "Enviar com Zelle", amount: "Valor", memo: "Memo", recipient: "Destinatário",
    order_received_msg: "Recebemos o seu pedido.", zelle_awaiting_msg: "Seu pagamento Zelle está aguardando confirmação.",
    zelle_memo_help: "Inclua o número do pedido no memo para identificarmos seu pagamento.",
    benefit_print_t: "Impressão de alta qualidade", benefit_print_d: "Brilhante, ponta a ponta, com cantos arredondados.",
    benefit_gift_t: "Perfeito para presentear", benefit_gift_d: "Adicione embalagem de presente no checkout.",
    benefit_memories_t: "Suas memórias favoritas", benefit_memories_d: "Suas fotos, lindamente impressas.",
    benefit_decor_t: "Decoração linda em casa", benefit_decor_d: "Dê vida à sua geladeira e muito mais.",
    play_video: "Reproduzir vídeo",
    product_details_title: "Detalhes do produto",
    pd_size_label: "Tamanho", pd_corners_label: "Cantos", pd_finish_label: "Acabamento", pd_backing_label: "Base",
    pd_corners_v: "Cantos levemente arredondados", pd_finish_v: "Impressão fotográfica brilhante de ponta a ponta — sem bordas", pd_backing_v: "Base magnética flexível",
    custom_card_title: "Escolha a quantidade", your_price: "Seu preço",
    cta_video_q: "Pronto para transformar suas fotos em ímãs?",
    cta_want_mine: "Quero o meu",
    cta_create_now: "Crie os seus agora",
    promo_headline: "Suas memórias merecem um lugar onde você possa vê-las.",
    promo_support: "Transforme suas fotos favoritas em ímãs feitos para a sua geladeira.",
    cta_create_q: "Pronto para criar os seus?",
    cta_create_desc: "Transforme suas fotos favoritas em ímãs feitos só para você.",
    fo_title: "Ganhe 10% de desconto no primeiro pedido",
    fo_subtitle: "Informe seu e-mail para desbloquear 10% de desconto nos seus ímãs.",
    fo_email_placeholder: "Endereço de e-mail",
    fo_cta: "QUERO 10% OFF",
    fo_no_thanks: "Não, obrigado",
    fo_invalid_email: "Digite um endereço de e-mail válido.",
    fo_not_eligible: "Este e-mail não é elegível para a oferta de primeiro pedido.",
    fo_applied_toast: "Desconto de {pct}% do primeiro pedido aplicado!",
    fo_savings: "✓ {pct}% de desconto do primeiro pedido — Você economiza {amt}",
    fo_remove: "Remover",
    fo_original: "Preço original",
    fo_discounted: "Ímãs com desconto",
    first_order_discount_label: "Desconto de {pct}% (primeiro pedido)",
    free_unlocked: "✓ Você desbloqueou o FRETE GRÁTIS",
    free_away_value: "Faltam {amt} para o FRETE GRÁTIS",
    free_hint_value: "Frete grátis em pedidos a partir de {amt}",
    free_away_qty: "Adicione mais {n} ímãs para desbloquear o FRETE GRÁTIS",
    free_hint_qty: "Frete grátis a partir de {n} ímãs",
    lang_label: "PT",
  },
};

const LangContext = createContext(null);

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem("mm_lang") || "en");
  const toggle = useCallback(() => {
    setLang((l) => { const nl = l === "en" ? "pt" : "en"; localStorage.setItem("mm_lang", nl); return nl; });
  }, []);
  const t = useCallback((key, vars) => {
    let s = (CATALOG[lang] && CATALOG[lang][key]) || CATALOG.en[key] || key;
    if (vars) Object.keys(vars).forEach((k) => (s = s.replace(`{${k}}`, vars[k])));
    return s;
  }, [lang]);
  return <LangContext.Provider value={{ lang, toggle, t }}>{children}</LangContext.Provider>;
}

export function useT() {
  const ctx = useContext(LangContext);
  if (!ctx) return { lang: "en", toggle: () => {}, t: (k) => k };
  return ctx;
}
